import React from "react";
import styles from "../styles/webStyles";
import { Grid } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { useMediaQuery } from "react-responsive";
import PageTitle from "../components/Website/PageTitle";
import PageContainer from "../components/PageContainer";

const DataPrivacy = () => {
  const isPhone = useMediaQuery({ query: "(max-width: 812px)" });

  return (
    <PageContainer>
      <Helmet>
        <title>Data Privacy | NTI</title>
      </Helmet>
      <PageTitle title="Data Privacy" />

      <div className="container">
        <Grid container>
          <Grid items xs={12}>
            <div style={{ margin: "5rem 3rem" }}>
              <h2
                style={{
                  ...styles.subHeader,
                  fontSize: isPhone ? "20px" : "30px",
                  fontWeight: 900,
                  margin: 0,
                }}
              >
                Data Privacy Policy
              </h2>

              <p>
                The Accelerated Teacher Professionalization Pathway (ATPP),
                implemented by the National Teachers’ Institute (NTI), respects
                your privacy and is committed to protecting your personal data
                in line with the Nigeria Data Protection Act 2023.
              </p>
              <p>
                This Privacy Policy explains how we collect, use, and protect
                your data when you use the ATPP platform.
              </p>

              <h3>1. Introduction</h3>
              <p>
                This Privacy Policy applies to the ATPP platform and describes
                how personal data is handled for learners and other stakeholders
                who interact with the platform.
              </p>

              <h3>2. Information We Collect</h3>
              <p>We may collect:</p>
              <ul>
                <li>Personal details (name, email, phone number)</li>
                <li>Professional information (school, qualifications)</li>
                <li>Learning data (courses, assessments, progress)</li>
                <li>Technical data (device, IP address, usage logs)</li>
              </ul>

              <h3>3. How We Use Your Information</h3>
              <p>Your data is used to:</p>
              <ul>
                <li>Provide access to ATPP courses</li>
                <li>Track your learning progress and performance</li>
                <li>Issue certificates upon completion</li>
                <li>Improve learning experience and platform functionality</li>
                <li>Generate anonymized reports for education planning</li>
              </ul>

              <h3>4. Legal Basis for Processing</h3>
              <p>We process your data based on:</p>
              <ul>
                <li>Your participation in ATPP</li>
                <li>
                  Legal and public interest obligations in education
                </li>
                <li>Your consent (where required)</li>
              </ul>

              <h3>5. Data Sharing</h3>
              <p>We may share your data with:</p>
              <ul>
                <li>NTI and education authorities</li>
                <li>Accredited programme partners</li>
                <li>Technology providers supporting the LMS</li>
              </ul>
              <p>
                We do not sell your personal data.
              </p>

              <h3>6. Data Security</h3>
              <p>
                We use industry-standard measures to protect your data,
                including:
              </p>
              <ul>
                <li>Encryption</li>
                <li>Secure servers</li>
                <li>Access controls</li>
                <li>Continuous monitoring</li>
              </ul>

              <h3>7. Data Retention</h3>
              <p>Your data is retained:</p>
              <ul>
                <li>For the duration of your participation in ATPP</li>
                <li>As required for certification and compliance</li>
              </ul>
              <p>Then securely deleted or anonymized.</p>

              <h3>8. Your Rights</h3>
              <p>You have the right to:</p>
              <ul>
                <li>Access your data</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion (where applicable)</li>
                <li>Object to certain processing</li>
              </ul>
              <p>
                To exercise your rights, contact us using the details below.
              </p>

              <h3>9. Cookies and Tracking</h3>
              <p>We may use cookies to:</p>
              <ul>
                <li>Improve user experience</li>
                <li>Analyze platform usage</li>
                <li>Enhance performance</li>
              </ul>
              <p>You can control cookies through your browser settings.</p>

              <h3>10. Contact Information</h3>
              <p>For any data privacy concerns or requests:</p>
              <p style={{ marginBottom: "0.5rem" }}>
                <strong>Data Protection Officer (DPO)</strong>
                <br />
                National Teachers’ Institute (NTI)
              </p>
              <ul style={{ marginTop: 0 }}>
                <li>
                  Email: <span>[Insert Official Email]</span>
                </li>
                <li>
                  Phone: <span>[Insert Contact]</span>
                </li>
              </ul>

              <h3>11. Updates to This Policy</h3>
              <p>
                We may update this Privacy Policy periodically. Updates will be
                communicated via the platform.
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
    </PageContainer>
  );
};

export default DataPrivacy;

